export const AB_TEST_INJECTED_ELEMENT_ID = 'app-growthbook-features';
export const AB_TEST_DEVICE_ID_COOKIE_NAME = 'device-id';
export const AB_TEST_FEATURE_FLAVOR_SELECTOR = '[flavor]';
